import Template from './Source.hbs';
import Button from 'views/components/wysiwyg/parts/buttons/Button';

export default class Source extends Button {

    initializeButton() {
        this.icon = Template();
        this.tooltip = window.i18n.gettext('View source')
    }

    onClickButton(e) {
        // Prevent weird behaviour by blocking default actions
        this.stopAllEvents(e)

        const editor = this.wysiwyg.editor

        // Check if the editor is hidden
        if (this.wysiwyg.editor.isHidden()) {

            // Deactive the button
            this.setDeactive()

            // Unset fixed height from source code text area.
            editor.getElement().style.height = null

            // Reshow the editor
            editor.show()

            // Place cursor back in editor
            editor.focus()
            if (this.bookmark) {
                editor.selection.moveToBookmark(this.bookmark)
                delete this.bookmark
            }

            // When the editor is not hidden
        } else {

            // Activate the button
            this.setActive()

            // Save bookmark so we can restore cursor position it can be restored when editor is shown again.
            this.bookmark = editor.selection.getBookmark(2)

            // Set source code text area to same height as the WYSIWYG editor.
            const textareaEl = editor.getElement()
            textareaEl.style.height = `${this.wysiwyg.editor.getContainer().clientHeight}px`

            // Hide the editor
            editor.hide()

            // Place cursor at the start of text area.
            textareaEl.focus()
            textareaEl.setSelectionRange(0, 0)
        }
    }

}
